module.exports = __webpack_public_path__ + "img/m_business_bg.883590c0.png";